import { useState } from "react";
import { Button } from "risa-oasis-ui_v2";
import LabelValue from "./labelValue";

interface EmailPasswordCardProps {
  email: string;
  onEdit?: () => void;
  onViewPassword?: () => Promise<string>;
  onViewPasswordError?: () => void;
}

const EmailPasswordCard = ({
  email,
  onEdit,
  onViewPassword,
  onViewPasswordError,
}: EmailPasswordCardProps) => {
  const [passwordState, setPasswordState] = useState({
    isVisible: false,
    value: "",
    isLoading: false,
  });

  const togglePasswordVisibility = async () => {
    if (!passwordState.isVisible) {
      setPasswordState((prev) => ({ ...prev, isLoading: true }));
      try {
        if (onViewPassword) {
          const decryptedPassword = await onViewPassword();
          setPasswordState({
            isVisible: true,
            value: decryptedPassword,
            isLoading: false,
          });
        }
      } catch (error) {
        console.error("Error fetching password:", error);
        setPasswordState((prev) => ({
          ...prev,
          isVisible: false,
          isLoading: false,
        }));
        onViewPasswordError?.();
      }
    } else {
      setPasswordState({
        isVisible: false,
        value: "",
        isLoading: false,
      });
    }
  };

  return (
    <div className="email-password-card flex w-full flex-row items-center justify-between rounded-lg border border-primaryGray-14 bg-white p-6 shadow-sm">
      <div className="flex flex-row items-center gap-12">
        <LabelValue label="Email" value={email || "--"} />
        <LabelValue
          label="Password"
          value={passwordState.isVisible ? passwordState.value : "••••••••••••"}
          className="font-mono tracking-wider"
        />
      </div>

      <div className="flex flex-row items-center gap-3">
        <Button
          buttonType="secondary"
          size="medium"
          disabled={passwordState.isLoading}
          onClick={togglePasswordVisibility}
        >
          {passwordState.isLoading
            ? "Loading..."
            : passwordState.isVisible
              ? "Hide"
              : "View"}
        </Button>
        <Button
          buttonType="primary"
          size="medium"
          disabled={false}
          onClick={() => onEdit?.()}
        >
          Edit
        </Button>
      </div>
    </div>
  );
};

export default EmailPasswordCard;
